<template>
  <div
    class="widget widget-stats mb-7px"
    :class="{
      'bg-orange': task.operator_name == 'nincs',
      'bg-gray': task.operator_name != 'nincs' && user.id != task.operator_id,
      'bg-success':
        task.operator_name != 'nincs' && user.id == task.operator_id,
    }"
  >
    <div class="stats-icon">
      <i v-if="task.security_type == 1" class="fa fa-unlock"></i>
      <i v-else-if="task.security_type == 3" class="fa fa-charging-station"></i>
      <i v-else class="fa fa-bolt"></i>
    </div>
    <div class="stats-content">
      <div class="stats-title text-truncate">
        {{ task.owner_name }}
        <span class="float-end"
          ><span class="badge bg-secondary">#{{ task.id }}</span></span
        ><br />
        <span class="fw-lighter fs-9px">{{
          task.created_at | moment("YYYY-MM-DD, HH:mm")
        }}</span>
      </div>
      <div
        class="stats-number text-truncate"
        v-b-tooltip.hover
        :title="task.name"
      >
        {{ task.task_name }}
      </div>
      <div class="stats-desc">
        <h6 title="Kék lakat felvevő">
          <i class="fa-solid fa-helmet-safety"></i>
          {{ task.ddc_user_name }}
        </h6>
        <h6 title="Operátor">
          <i class="fa-solid fa-user-astronaut"></i>
          {{ task.operator_name }}
        </h6>
      </div>
      <div class="stats-link" v-if="user">
        <a href="javascript:;" @click="taskLink(task)">
          <span v-if="this.user.role_id == 7 && task.operator_name == 'nincs'"
            >Felveszem
          </span>
          <span v-else>Munkafolyamathoz </span>
          <i class="fa fa-arrow-alt-circle-right"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Task from "../apis/Task.js";
export default {
  props: { task: Object },
  data() {
    return {};
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    taskLink(task) {
      if (this.user.role_id == 7 && task.operator_name == "nincs") {
        this.acceptTask(task.id);
      } else {
        this.$router.push({ path: "/tasks/" + task.id + "/edit" });
      }
    },
    acceptTask(task_id) {
      this.$swal({
        title: "Biztos felveszed a feladatot?",
        text: "ha felveszed a feladatot más operátorok nem szerkeszthetik!",
        type: "warning",
        icon: "question",
        iconColor: "orange",
        showCancelButton: true,
        showDenyButton: true,
        buttonsStyling: false,
        confirmButtonText: "Felveszem",
        cancelButtonText: "Mégsem",
        denyButtonText: "Megtekintem",
        confirmButtonClass: "btn btn-lg me-15px btn-warning",
        denyButtonClass: "btn btn-lg me-15px bg-pink text-white",
        cancelButtonClass: "btn btn-lg btn-default",
      }).then((response) => {
        if (response.isConfirmed === true) {
          Task.setOperator(task_id, { operator_id: this.user.id }).then(
            (response) => {
              this.$router.push({
                path: "/tasks/" + response.data.id + "/edit",
              });
            }
          );
        }
        if (response.isDenied === true) {
          this.$router.push({ path: "/tasks/" + this.task.id + "/edit" });
        }
      });
    },
  },
};
</script>
